import React from "react";
import "./App.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Navbar from "./Navbar";
import Alert from "./Alert";
import About from "./About";
import User from "./User";
import GithubState from "./context/GithubState";
import AlertState from "./context/AlertState";
import Home from "./Home";
import NotFound from "./NotFound";

function App() {
  return (
    <GithubState>
      <AlertState>
        <Router>
          <div className="App">
            <Navbar />
            <div className="container">
              <Alert />
              <Switch>
                <Route exact path="/" component={Home}></Route>
              </Switch>
              <Route exact path="/about" component={About}></Route>
              <Route exact path="/user/:login" component={User}></Route>
              {/* <Route component={NotFound} /> */}
            </div>
          </div>
        </Router>
      </AlertState>
    </GithubState>
  );
}

export default App;
